var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAiModelScaleButton = function SvgIconAiModelScaleButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.834 11.003c0 4.32 0 6.48 1.342 7.823S6.68 20.168 11 20.168s6.482 0 7.825-1.342c1.244-1.244 1.335-3.19 1.342-6.908M10.084 1.836c-3.718.006-5.664.098-6.908 1.342-.748.748-1.08 1.75-1.226 3.241"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m11.917 10.086 8.25-8.25m0 0h-4.899m4.899 0v4.899m-.917-3.982L11 11.003m0 0h3.667m-3.667 0V7.336"
  }))));
};
export default SvgIconAiModelScaleButton;